var observeDOM = (function () {
  var MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) {
      return;
    }

    if (MutationObserver) {
      var mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(obj, { childList: true, subtree: true });
      return mutationObserver;
    } else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();

 
 

$(document).on("click", '.search [type="reset"]', function (e) {
  e.preventDefault();
  document.location = "https://keat.mx/collections/all";
  return false;
});
 
  

$(document).ready(function () {
  if (document.location.href == "https://keat.mx/pages/kaldos") {
    document.location = "https://keat.mx/products/crea-tu-paquete-ideal";
  }
 

  if ($('.featured-product-container [href="/products/programa-menu-keat"]')) {
    $('.featured-product-container [href="/products/programa-menu-keat"]').attr(
      "href",
      "/products/programa-menu-keat?variant=47757544980785"
    );
  }

  if (mobileCheck()) {
    if ($("product-recommendations")) {
      $(".product__info-wrapper").after($("product-recommendations"));
    }
  }
  if ($("[data-boton-pago]")) {
    $("[data-boton-pago]").prepend($(".product-form__quantity"));
  }
  if (
    $(
      'product-info[data-url="/products/programa-menu-keat"] variant-radios .product-form__input'
    )
  ) {
    $(
      'product-info[data-url="/products/programa-menu-keat"] variant-radios .product-form__input'
    ).attr("id", "tuneup-variant-radios");
  }

  if (
    $(
      'product-info[data-url="/products/programa-reto-keat"] variant-radios .product-form__input'
    )
  ) {
    $(
      'product-info[data-url="/products/programa-reto-keat"] variant-radios .product-form__input'
    ).attr("id", "tuneup-variant-radios");
  }

  if (
    $(
      'product-info[data-url="/products/tune-up"] variant-radios .product-form__input'
    )
  ) {
    $(
      'product-info[data-url="/products/tune-up"] variant-radios .product-form__input'
    ).attr("id", "tuneup-variant-radios");
  }

  if ($("product-info[data-url='/products/tune-up'] .precio-producto-main")) {
    observeDOM(
      $("product-info[data-url='/products/tune-up'] .precio-producto-main")[0],
      function (m) {
        $("#fecha-inicio").val("").trigger("input");
        $(".product-form__submit").attr("disabled", true);
      }
    );
  }

  if (
    $(
      "product-info[data-url='/products/programa-menu-keat'] .precio-producto-main"
    )
  ) {
    observeDOM(
      $(
        "product-info[data-url='/products/programa-menu-keat'] .precio-producto-main"
      )[0],
      function (m) {
        $("#fecha-inicio").val("").trigger("input");
        $("#turno-entrega-producto-date-builder").val("").trigger("input");
        $(".product-form__submit").attr("disabled", true);
      }
    );
  }
  if (
    $(
      "product-info[data-url='/products/programa-reto-keat'] .precio-producto-main"
    )
  ) {
    observeDOM(
      $(
        "product-info[data-url='/products/programa-reto-keat'] .precio-producto-main"
      )[0],
      function (m) {
        $("#fecha-inicio").val("").trigger("input");
        $("#turno-entrega-producto-date-builder").val("").trigger("input");
        $(".product-form__submit").attr("disabled", true);
      }
    );
  }
});

$(document).on("click", "#cerrar-cart-notification", function (e) {
  e.preventDefault();
  document.getElementById("cart-notification").classList.remove("active");
  return false;
});

/*
document.addEventListener("sealsubs:subscription_widget_created", function (e) {
  $(
    "#ProductInfo-template--22918306136369__main quantity-input,#ProductInfo-template--22918306136369__main [data-boton-pago]"
  ).addClass("visible");
});
*/
 
 